require('./dist/typography/ds6/typography.css');
